import { LocationData, SET_LOCATIONS } from '../actions/businesses';

export interface LocationsState {
  locations: LocationData[];
  totalPages: number;
  totalElements: number;
}

const initialState: LocationsState = {
  locations: [],
  totalPages: 0,
  totalElements: 0,
};

// eslint-disable-next-line @typescript-eslint/default-param-last
const locationsReducer = (state = initialState, action: any): LocationsState => {
  switch (action.type) {
    case SET_LOCATIONS:
      return {
        locations: action.payload.content,
        totalPages: action.payload.totalPages,
        totalElements: action.payload.totalElements,
      };
    default:
      return state;
  }
};

export default locationsReducer;
